import { URLASSOLUTO, URLASSOLUTOISTITUZIONALE } from "./variables";
//import './jquery.flexdatalist'; // messo script localmente perchè non funziona da node_modules...

$(document).ready(function () {
    $("body").on("change", ".filterblock input", function () {
        $(this)
            .closest(".filterblock")
            .find(".typeFiler")
            .prop("checked", true);
        //$(this).closest("form").submit();
        let $checked = 0;
        $(this)
            .closest(".filterblock")
            .find("input[type=checkbox]")
            .each(function () {
                if ($(this).prop("checked")) {
                    $checked = 1;
                }
            });
        if ($checked == 1) {
            $(this)
                .closest(".filterblock")
                .find(".cancella-filtra")
                .removeClass("d-none");
        } else {
            $(this)
                .closest(".filterblock")
                .find(".cancella-filtra")
                .addClass("d-none");
        }
        var form = $(this).closest("form");
        $.ajax({
            url: URLASSOLUTO + "/api/getFilter",
            data: {
                forminfo: form.serialize(),
            },
            method: "POST",
            dataType: "html",
            beforeSend: function () {
                $("#preload").fadeIn();
            },
        }).done(function (result) {
            let obj = JSON.parse(result);
            if (obj.htmlMenu !== "") {
                $(".htmlMenu").replaceWith(obj.htmlMenu);
            }
            if (obj.htmlContainer !== "") {
                $(".htmlContainer").replaceWith(obj.htmlContainer);
            }
            $("#preload").fadeOut();
        });
    });
    $("body").on("click", ".filterblock .cancella-filtra", function () {
        $(this).closest(".filterblock").find("input").prop("checked", false);
        $(this).toggleClass("d-none");

        var form = $(this).closest("form");
        //$(this).closest("form").submit();
        $.ajax({
            url: URLASSOLUTO + "/api/getFilter",
            data: {
                forminfo: form.serialize(),
            },
            method: "POST",
            dataType: "html",
            beforeSend: function () {
                $("#preload").fadeIn();
            },
        }).done(function (result) {
            let obj = JSON.parse(result);
            if (obj.htmlMenu !== "") {
                $(".htmlMenu").replaceWith(obj.htmlMenu);
            }
            if (obj.htmlContainer !== "") {
                $(".htmlContainer").replaceWith(obj.htmlContainer);
            }
            $("#preload").fadeOut();
        });
    });
});
